import { render } from "./IdentifierInput.vue?vue&type=template&id=60fd25da"
import script from "./IdentifierInput.vue?vue&type=script&lang=js"
export * from "./IdentifierInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/packs/components/IdentifierInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "60fd25da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('60fd25da', __exports__)) {
    api.reload('60fd25da', __exports__)
  }
  
  module.hot.accept("./IdentifierInput.vue?vue&type=template&id=60fd25da", () => {
    api.rerender('60fd25da', render)
  })

}


export default __exports__